"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = void 0;
/**
 * Represents an abstract command in a course. Commands start with a hash (`#`)
 * character. Anything that does not start with a hash symbol will be treated as
 * a note sequence.
 */
class Command {
    constructor(commandType) {
        this.commandType = commandType;
    }
    toString() {
        return `#${this.commandType}`;
    }
}
exports.Command = Command;
